import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiCall } from '../../../API';
import * as Toast from "../../../components/shared/Toast";

export const getFromRestaurantsByCustomerAction = createAsyncThunk(
    "CopyMenu/getFromRestaurantsByCustomer",
    async (data) => {
        let d = {
            device: 1,
            tenantID: data.tenantId || data.tenantID
        };
        return apiCall("/manage/business/getallrestaurant", "POST", d, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError && !response.data.HasError) {
                        return response.data;
                    } else {
                        Toast.error(response.data.Message ? response.data.Message.Message : (response.data.message ? response.data.message.message : "Failed to fetch restaurants"));
                        return Promise.reject(response.data.Message || response.data.message);
                    }
                }
            })
            .catch((error) => {
                Toast.error(error);
                return Promise.reject(error);
            });
    }
);

export const getToRestaurantsByCustomerAction = createAsyncThunk(
    "CopyMenu/getToRestaurantsByCustomer",
    async (data) => {
        let d = {
            device: 1,
            tenantID: data.tenantId || data.tenantID
        };
        return apiCall("/manage/business/getallrestaurant", "POST", d, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError && !response.data.HasError) {
                        return response.data;
                    } else {
                        Toast.error(response.data.Message ? response.data.Message.Message : (response.data.message ? response.data.message.message : "Failed to fetch restaurants"));
                        return Promise.reject(response.data.Message || response.data.message);
                    }
                }
            })
            .catch((error) => {
                Toast.error(error);
                return Promise.reject(error);
            });
    }
);

export const copyRestaurantMenuACTION = createAsyncThunk(
    "CopyMenu/copyRestaurantMenu",
    async (data) => {
        return apiCall("/manage/business/copyrestaurantmenu", "POST", data, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError) {
                        Toast.success(response.data.message ? response.data.message.message : "Menu copied successfully");
                        return response.data;
                    } else {
                        Toast.error(response.data.message ? response.data.message.message : "Failed to copy menu");
                        return Promise.reject(response.data.message);
                    }
                } else {
                    Toast.error(response?.data?.message?.message || "Error copying menu");
                    return Promise.reject(response?.data);
                }
            })
            .catch((error) => {
                Toast.error(error);
                return Promise.reject(error);
            });
    }
);
